import type { isSupported } from '@loomhq/record-sdk';

type ReturnValue = ReturnType<typeof isSupported>;

export async function isSdkSupported(): ReturnValue {
  const module = await import('@loomhq/record-sdk');

  const { isSupported } = module;

  return isSupported();
}
